export const CrossIcon = (props) => (
  <svg
    {...props}
    width={props?.width || '8'}
    height={props?.height || '8'}
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.795.23 3.966 3.056 1.138.23l-.943.943L3.023 4 .195 6.828l.943.943 2.828-2.828L6.795 7.77l.942-.943L4.91 4l2.828-2.828L6.795.23Z"
      fill="currentColor"
    />
  </svg>
);

export const TicketStarIcon = (props) => (
  <svg
    {...props}
    width={props?.width || '20'}
    height={props?.height || '20'}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.875 3.217H8.258v2.516a.585.585 0 0 1-.583.584.585.585 0 0 1-.583-.584V3.217h-.967c-3.292 0-4.375.983-4.45 4.058a.565.565 0 0 0 .167.417c.108.116.25.175.416.175A2.14 2.14 0 0 1 4.383 10a2.141 2.141 0 0 1-2.125 2.133.56.56 0 0 0-.416.175.566.566 0 0 0-.167.417c.075 3.075 1.158 4.058 4.45 4.058h.967v-2.516c0-.325.266-.584.583-.584.317 0 .583.259.583.584v2.516h5.617c3.417 0 4.458-1.041 4.458-4.458v-4.65c0-3.417-1.041-4.458-4.458-4.458Zm1.517 6.7-.775.75c-.034.025-.042.075-.034.116l.184 1.059a.511.511 0 0 1-.209.508.51.51 0 0 1-.541.042l-.959-.5a.142.142 0 0 0-.116 0l-.959.5a.494.494 0 0 1-.241.058.52.52 0 0 1-.508-.608l.183-1.059a.15.15 0 0 0-.034-.116l-.775-.75a.513.513 0 0 1-.133-.525.492.492 0 0 1 .417-.35l1.066-.159a.166.166 0 0 0 .1-.066l.475-.967a.521.521 0 0 1 .925 0l.475.967c.017.041.05.066.092.066l1.067.159c.2.025.358.166.416.35a.478.478 0 0 1-.116.525Z"
      fill="currentColor"
    />
  </svg>
);

export const BoxColorIcon = (props) => (
  <svg
    {...props}
    width={props?.width || '36'}
    height={props?.height || '36'}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#a)">
      <path
        d="M34.918 7.425 18.187 13.76l.161 21.009 16.57-6.547V7.425ZM10.956 10.6l16.811-6.165-3.398-1.29L8.125 9.556l2.83 1.046Zm1.034.38 5.832 2.15 16.453-6.226-5.488-2.084-16.797 6.16Zm-4.6 4.35c.505.16 1.016.33 1.515.509.541.188 1.088.39 1.632.6l.057-5.216-3.118-1.149-.086 5.254v.003ZM1.378 7.07 7.12 9.188l16.26-6.415L18.02.74 1.377 7.07Zm-.655.52v21.018l16.902 6.173-.162-21.017-6.152-2.272-.056 5.474a.367.367 0 0 1-.162.294.367.367 0 0 1-.2.056.366.366 0 0 1-.138-.024 52.897 52.897 0 0 0-2.098-.781 50.451 50.451 0 0 0-1.743-.579.36.36 0 0 1-.254-.344l.099-5.77-6.036-2.23v.002ZM0 28.854V7.075c0-.044.012-.082.024-.117v-.006s.006-.015.012-.018a.348.348 0 0 1 .054-.085c.006-.012.018-.02.024-.03a.38.38 0 0 1 .08-.052.125.125 0 0 1 .024-.018c.003 0 .006-.003.012-.003L17.89.023a.377.377 0 0 1 .261 0l17.26 6.55.006.005s.018.006.024.015a.38.38 0 0 1 .08.053l.03.03c.021.023.04.052.054.082 0 .006.006.014.012.02v.006c.015.038.024.08.024.12v21.553c0 .141-.09.273-.227.326L18.13 35.615a.387.387 0 0 1-.102.017c-.012.003-.02.006-.032.006h-.003a.357.357 0 0 1-.123-.02L.24 29.186A.358.358 0 0 1 0 28.85v.003Z"
        fill="#313447"
      />
      <path
        d="m18.187 13.757 16.731-6.332v20.794l-16.57 6.55-.161-21.012Z"
        fill="#CC9671"
      />
      <path
        d="M10.956 10.6 8.122 9.556l16.244-6.409 3.399 1.293-16.81 6.162Z"
        fill="#FFE17D"
      />
      <path
        d="M7.12 9.188 1.378 7.069 18.019.737l5.36 2.033L7.12 9.188Z"
        fill="#EDBA94"
      />
      <path
        d="M10.534 16.442a49.218 49.218 0 0 0-1.632-.599 42.714 42.714 0 0 0-1.515-.508l.086-5.254 3.118 1.149-.057 5.215v-.003Z"
        fill="#FFE17D"
      />
      <path
        d="m17.822 13.13-5.835-2.147L28.784 4.82l5.49 2.084-16.452 6.226ZM.724 28.604V7.586l6.035 2.225-.099 5.77a.36.36 0 0 0 .254.344c.583.183 1.17.376 1.743.58.703.243 1.408.508 2.099.78.044.018.09.024.137.024.069 0 .14-.017.2-.056a.36.36 0 0 0 .162-.293l.057-5.475 6.152 2.272.161 21.018-16.901-6.17Z"
        fill="#EDBA94"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h36v36H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const EyeIcon = (props) => (
  <svg
    {...props}
    fill="#000000"
    height={props?.width || '25'}
    width={props?.width || '25'}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    enable-background="new 0 0 512 512"
  >
    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {' '}
      <g>
        {' '}
        <path d="m494.8,241.4l-50.6-49.4c-50.1-48.9-116.9-75.8-188.2-75.8s-138.1,26.9-188.2,75.8l-50.6,49.4c-11.3,12.3-4.3,25.4 0,29.2l50.6,49.4c50.1,48.9 116.9,75.8 188.2,75.8s138.1-26.9 188.2-75.8l50.6-49.4c4-3.8 11.7-16.4 0-29.2zm-238.8,84.4c-38.5,0-69.8-31.3-69.8-69.8 0-38.5 31.3-69.8 69.8-69.8 38.5,0 69.8,31.3 69.8,69.8 0,38.5-31.3,69.8-69.8,69.8zm-195.3-69.8l35.7-34.8c27-26.4 59.8-45.2 95.7-55.4-28.2,20.1-46.6,53-46.6,90.1 0,37.1 18.4,70.1 46.6,90.1-35.9-10.2-68.7-29-95.7-55.3l-35.7-34.7zm355,34.8c-27,26.3-59.8,45.1-95.7,55.3 28.2-20.1 46.6-53 46.6-90.1 0-37.2-18.4-70.1-46.6-90.1 35.9,10.2 68.7,29 95.7,55.4l35.6,34.8-35.6,34.7z"></path>{' '}
      </g>{' '}
    </g>
  </svg>
);

export const DocumentIcon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.3332 8.33333V12.5C18.3332 16.6667 16.6665 18.3333 12.4998 18.3333H7.49984C3.33317 18.3333 1.6665 16.6667 1.6665 12.5V7.5C1.6665 3.33333 3.33317 1.66667 7.49984 1.66667H11.6665"
      stroke="#93959E"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.3332 8.33333H14.9998C12.4998 8.33333 11.6665 7.5 11.6665 5V1.66667L18.3332 8.33333Z"
      stroke="#93959E"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const EyeSlashIcon = (props) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    height={props?.width || '25'}
    width={props?.width || '25'}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {' '}
      <path
        d="M2.99902 3L20.999 21M9.8433 9.91364C9.32066 10.4536 8.99902 11.1892 8.99902 12C8.99902 13.6569 10.3422 15 11.999 15C12.8215 15 13.5667 14.669 14.1086 14.133M6.49902 6.64715C4.59972 7.90034 3.15305 9.78394 2.45703 12C3.73128 16.0571 7.52159 19 11.9992 19C13.9881 19 15.8414 18.4194 17.3988 17.4184M10.999 5.04939C11.328 5.01673 11.6617 5 11.9992 5C16.4769 5 20.2672 7.94291 21.5414 12C21.2607 12.894 20.8577 13.7338 20.3522 14.5"
        stroke="#000000"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>{' '}
    </g>
  </svg>
);

export const XCircleClose = (props) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    height={props?.width || '45'}
    width={props?.width || '45'}
  >
    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {' '}
      <circle
        cx="12"
        cy="12"
        r="9"
        fill="#bbb4b4"
        fill-opacity="0.24"
      ></circle>{' '}
      <path
        d="M9 9L15 15"
        stroke="#222222"
        stroke-width="1.2"
        stroke-linecap="round"
      ></path>{' '}
      <path
        d="M15 9L9 15"
        stroke="#222222"
        stroke-width="1.2"
        stroke-linecap="round"
      ></path>{' '}
    </g>
  </svg>
);

export const SuccessCircle = (props) => (
  <svg
    {...props}
    viewBox="0 0 1024 1024"
    xmlns="http://www.w3.org/2000/svg"
    fill="#000000"
    height={props?.width || '70'}
    width={props?.width || '70'}
  >
    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path
        fill="#1B9846"
        d="M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896zm-55.808 536.384-99.52-99.584a38.4 38.4 0 1 0-54.336 54.336l126.72 126.72a38.272 38.272 0 0 0 54.336 0l262.4-262.464a38.4 38.4 0 1 0-54.272-54.336L456.192 600.384z"
      ></path>
    </g>
  </svg>
);

export const FileAddIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
    height={props?.width || '24'}
    width={props?.width || '24'}
  >
    <g clip-path="url(#clip0_1688_108732)">
      <path
        d="M19.74 7.33018L15.3 2.33018C15.2065 2.22659 15.0924 2.14371 14.9649 2.08688C14.8375 2.03004 14.6995 2.00051 14.56 2.00018H6.56C6.22775 1.99622 5.89797 2.05774 5.5895 2.18124C5.28103 2.30473 4.9999 2.48778 4.76218 2.71993C4.52446 2.95209 4.33479 3.22879 4.20402 3.53425C4.07324 3.8397 4.00392 4.16793 4 4.50018V19.5002C4.00392 19.8324 4.07324 20.1607 4.20402 20.4661C4.33479 20.7716 4.52446 21.0483 4.76218 21.2804C4.9999 21.5126 5.28103 21.6956 5.5895 21.8191C5.89797 21.9426 6.22775 22.0041 6.56 22.0002H17.44C17.7723 22.0041 18.102 21.9426 18.4105 21.8191C18.719 21.6956 19.0001 21.5126 19.2378 21.2804C19.4755 21.0483 19.6652 20.7716 19.796 20.4661C19.9268 20.1607 19.9961 19.8324 20 19.5002V8.00018C19.9994 7.75234 19.9067 7.51358 19.74 7.33018ZM9 12.0002H12C12.2652 12.0002 12.5196 12.1055 12.7071 12.2931C12.8946 12.4806 13 12.735 13 13.0002C13 13.2654 12.8946 13.5198 12.7071 13.7073C12.5196 13.8948 12.2652 14.0002 12 14.0002H9C8.73478 14.0002 8.48043 13.8948 8.29289 13.7073C8.10536 13.5198 8 13.2654 8 13.0002C8 12.735 8.10536 12.4806 8.29289 12.2931C8.48043 12.1055 8.73478 12.0002 9 12.0002ZM15 18.0002H9C8.73478 18.0002 8.48043 17.8948 8.29289 17.7073C8.10536 17.5198 8 17.2654 8 17.0002C8 16.735 8.10536 16.4806 8.29289 16.2931C8.48043 16.1055 8.73478 16.0002 9 16.0002H15C15.2652 16.0002 15.5196 16.1055 15.7071 16.2931C15.8946 16.4806 16 16.735 16 17.0002C16 17.2654 15.8946 17.5198 15.7071 17.7073C15.5196 17.8948 15.2652 18.0002 15 18.0002ZM14.71 8.00018C14.5038 7.97988 14.3139 7.87942 14.1811 7.72043C14.0483 7.56144 13.9833 7.35666 14 7.15018V4.00018L17.74 8.00018H14.71Z"
        fill="#FF4D4D"
      />
    </g>
    <defs>
      <clipPath id="clip0_1688_108732">
        <rect width="24" height="24" rx="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const DiscountIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
    height={props?.width || '24'}
    width={props?.width || '24'}
  >
    <g clip-path="url(#clip0_1688_108743)">
      <path
        d="M22.9772 8.50303L20.9086 6.43444C20.7417 6.26979 20.5192 6.17365 20.2849 6.16498C20.0506 6.1563 19.8216 6.23571 19.643 6.38756C19.3672 6.62228 19.0133 6.74484 18.6515 6.73095C18.2896 6.71706 17.9462 6.56773 17.6892 6.31256C17.4342 6.05563 17.2849 5.71229 17.271 5.35054C17.2572 4.98879 17.3796 4.63501 17.6142 4.35928C17.7661 4.18066 17.8455 3.95164 17.8368 3.71736C17.8281 3.48308 17.732 3.26055 17.5673 3.09366L15.4969 1.02272C15.3219 0.848082 15.0848 0.75 14.8376 0.75C14.5904 0.75 14.3532 0.848082 14.1783 1.02272L10.8806 4.31991C10.677 4.52423 10.5235 4.77291 10.432 5.04647C10.4142 5.09906 10.3845 5.14685 10.3453 5.18611C10.306 5.22538 10.2582 5.25507 10.2056 5.27288C9.93195 5.36433 9.68324 5.51805 9.47906 5.72194L1.02281 14.1782C0.848174 14.3532 0.750092 14.5903 0.750092 14.8375C0.750092 15.0847 0.848174 15.3218 1.02281 15.4968L3.09375 17.5654C3.26064 17.73 3.48317 17.8262 3.71745 17.8348C3.95173 17.8435 4.18076 17.7641 4.35937 17.6122C4.63448 17.3756 4.98883 17.2517 5.35144 17.2653C5.71405 17.2789 6.05812 17.4291 6.3147 17.6857C6.57129 17.9423 6.72143 18.2863 6.73504 18.6489C6.74866 19.0115 6.62474 19.3659 6.38812 19.641C6.23627 19.8196 6.15686 20.0486 6.16554 20.2829C6.17421 20.5172 6.27035 20.7397 6.435 20.9066L8.50359 22.9752C8.67856 23.1499 8.91568 23.2479 9.16289 23.2479C9.4101 23.2479 9.64721 23.1499 9.82218 22.9752L18.2784 14.519C18.4822 14.3149 18.6359 14.0663 18.7275 13.7929C18.7452 13.7401 18.7749 13.6922 18.8143 13.6528C18.8537 13.6134 18.9016 13.5837 18.9544 13.566C19.2278 13.4745 19.4763 13.321 19.6805 13.1174L22.9776 9.81975C23.1517 9.64479 23.2493 9.40805 23.2492 9.16129C23.2491 8.91454 23.1513 8.67786 22.9772 8.50303ZM12.2723 7.11319C12.2027 7.18285 12.12 7.23811 12.029 7.27581C11.938 7.31351 11.8405 7.33292 11.7419 7.33292C11.6434 7.33292 11.5459 7.31351 11.4549 7.27581C11.3639 7.23811 11.2812 7.18285 11.2116 7.11319L10.672 6.57366C10.5348 6.4323 10.4587 6.24261 10.4602 6.04561C10.4617 5.8486 10.5406 5.66008 10.68 5.5208C10.8193 5.38153 11.0078 5.30267 11.2049 5.30127C11.4019 5.29987 11.5915 5.37605 11.7328 5.51334L12.2723 6.05241C12.342 6.12205 12.3973 6.20474 12.435 6.29574C12.4727 6.38675 12.4921 6.48429 12.4921 6.5828C12.4921 6.6813 12.4727 6.77884 12.435 6.86985C12.3973 6.96085 12.342 7.04354 12.2723 7.11319ZM14.3348 9.17569C14.1942 9.31623 14.0035 9.39518 13.8047 9.39518C13.6059 9.39518 13.4152 9.31623 13.2745 9.17569L12.7589 8.66006C12.6892 8.59041 12.634 8.50772 12.5963 8.41672C12.5586 8.32571 12.5392 8.22817 12.5392 8.12967C12.5392 8.03117 12.5586 7.93363 12.5963 7.84263C12.634 7.75162 12.6892 7.66893 12.7589 7.59928C12.8996 7.45861 13.0904 7.37959 13.2893 7.37959C13.3878 7.37959 13.4853 7.39899 13.5763 7.43668C13.6673 7.47438 13.75 7.52963 13.8197 7.59928L14.3353 8.11491C14.4052 8.18455 14.4607 8.2673 14.4986 8.35842C14.5364 8.44953 14.5559 8.54723 14.556 8.6459C14.556 8.74458 14.5366 8.84229 14.4988 8.93344C14.461 9.02459 14.4056 9.10739 14.3358 9.17709L14.3348 9.17569ZM16.3973 11.2382C16.3277 11.3078 16.245 11.3631 16.154 11.4008C16.063 11.4385 15.9655 11.4579 15.8669 11.4579C15.7684 11.4579 15.6709 11.4385 15.5799 11.4008C15.4889 11.3631 15.4062 11.3078 15.3366 11.2382L14.8209 10.7226C14.6837 10.5812 14.6076 10.3915 14.6091 10.1945C14.6106 9.9975 14.6895 9.80899 14.8289 9.66971C14.9682 9.53043 15.1567 9.45157 15.3538 9.45018C15.5508 9.44878 15.7404 9.52496 15.8817 9.66225L16.3973 10.1779C16.4674 10.2474 16.5231 10.3301 16.5612 10.4212C16.5993 10.5123 16.619 10.61 16.6192 10.7087C16.6194 10.8074 16.6001 10.9052 16.5625 10.9965C16.5248 11.0878 16.4695 11.1707 16.3997 11.2405L16.3973 11.2382ZM18.48 13.326C18.4103 13.3957 18.3277 13.4509 18.2367 13.4886C18.1457 13.5263 18.0481 13.5457 17.9496 13.5457C17.8511 13.5457 17.7536 13.5263 17.6626 13.4886C17.5715 13.4509 17.4889 13.3957 17.4192 13.326L16.883 12.7869C16.8118 12.7175 16.7552 12.6346 16.7164 12.5431C16.6776 12.4516 16.6574 12.3533 16.6569 12.2539C16.6564 12.1545 16.6757 12.056 16.7137 11.9641C16.7516 11.8722 16.8074 11.7888 16.8779 11.7187C16.9483 11.6486 17.032 11.5931 17.1241 11.5557C17.2161 11.5182 17.3147 11.4994 17.4141 11.5003C17.5135 11.5013 17.6117 11.522 17.7031 11.5612C17.7944 11.6005 17.877 11.6575 17.9461 11.729L18.4828 12.2676C18.5524 12.3372 18.6077 12.4199 18.6453 12.511C18.683 12.602 18.7023 12.6995 18.7023 12.798C18.7023 12.8966 18.6828 12.9941 18.6451 13.0851C18.6073 13.1761 18.552 13.2587 18.4823 13.3283L18.48 13.326Z"
        fill="#4991F2"
      />
    </g>
    <defs>
      <clipPath id="clip0_1688_108743">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const CallIcon = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    height={props?.width || '34'}
    width={props?.width || '34'}
  >
    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {' '}
      <path
        d="M8 13.4782L8 12.8617C8 12.8617 8 11.3963 12 11.3963C16 11.3963 16 12.8617 16 12.8617V13.25C16 14.2064 16.7227 15.0192 17.7004 15.1625L19.7004 15.4556C20.9105 15.6329 22 14.7267 22 13.5429V11.4183C22 10.8313 21.8162 10.2542 21.3703 9.85601C20.2296 8.83732 17.4208 7 12 7C6.25141 7 3.44027 9.58269 2.44083 10.7889C2.1247 11.1704 2 11.6525 2 12.1414L2 14.0643C2 15.3623 3.29561 16.292 4.57997 15.9156L6.57997 15.3295C7.42329 15.0823 8 14.3305 8 13.4782Z"
        fill="#ffffff"
      ></path>{' '}
    </g>
  </svg>
);

export const DownloadIcon = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    height={props?.width || '24'}
    width={props?.width || '24'}
  >
    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {' '}
      <path
        d="M12 16L12 8"
        stroke="#323232"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>{' '}
      <path
        d="M9 13L11.913 15.913V15.913C11.961 15.961 12.039 15.961 12.087 15.913V15.913L15 13"
        stroke="#323232"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>{' '}
      <path
        d="M3 15L3 16L3 19C3 20.1046 3.89543 21 5 21L19 21C20.1046 21 21 20.1046 21 19L21 16L21 15"
        stroke="#323232"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>{' '}
    </g>
  </svg>
);

export const XCloseCard = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    height={props?.width || '24'}
    width={props?.width || '24'}
  >
    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.207 6.207a1 1 0 0 0-1.414-1.414L12 10.586 6.207 4.793a1 1 0 0 0-1.414 1.414L10.586 12l-5.793 5.793a1 1 0 1 0 1.414 1.414L12 13.414l5.793 5.793a1 1 0 0 0 1.414-1.414L13.414 12l5.793-5.793z"
        fill="#9AA2B1"
      ></path>
    </g>
  </svg>
);

export const MessageNotifIcon = (props) => (
  <svg
    {...props}
    height={props?.width || '24'}
    width={props?.width || '24'}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M5 18V21.766L6.515 20.857L11.277 18H16C17.103 18 18 17.103 18 16V8C18 6.897 17.103 6 16 6H4C2.897 6 2 6.897 2 8V16C2 17.103 2.897 18 4 18H5ZM4 8H16V16H10.723L7 18.234V16H4V8Z"
      fill="white"
    />
    <path
      d="M20 2H19H16.998H8C6.897 2 6 2.897 6 4H16.586H18C19.103 4 20 4.897 20 6V7.414V12V14C21.103 14 22 13.103 22 12V7V5V4C22 2.897 21.103 2 20 2Z"
      fill="white"
    />
  </svg>
);

export const ArrowRightIcon = (props) => (
  <svg
    {...props}
    height={props?.width || '16'}
    width={props?.width || '17'}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 17 16"
    fill="none"
  >
    <path
      d="M9.27114 3.52901L8.32847 4.47168L11.1905 7.33368L4.7998 7.33368L4.7998 8.66701L11.1905 8.66701L8.32847 11.529L9.27114 12.4717L13.7425 8.00035L9.27114 3.52901Z"
      fill="#9AA4B2"
    />
  </svg>
);

export const AlertIcon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="-0.5 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.8809 16.15C10.8809 16.0021 10.9101 15.8556 10.967 15.7191C11.024 15.5825 11.1073 15.4586 11.2124 15.3545C11.3175 15.2504 11.4422 15.1681 11.5792 15.1124C11.7163 15.0567 11.8629 15.0287 12.0109 15.03C12.2291 15.034 12.4413 15.1021 12.621 15.226C12.8006 15.3499 12.9399 15.5241 13.0211 15.7266C13.1024 15.9292 13.122 16.1512 13.0778 16.3649C13.0335 16.5786 12.9272 16.7745 12.7722 16.9282C12.6172 17.0818 12.4204 17.1863 12.2063 17.2287C11.9922 17.2711 11.7703 17.2494 11.5685 17.1663C11.3666 17.0833 11.1938 16.9426 11.0715 16.7618C10.9492 16.5811 10.8829 16.3683 10.8809 16.15ZM11.2408 13.42L11.1008 8.20001C11.0875 8.07453 11.1008 7.94766 11.1398 7.82764C11.1787 7.70761 11.2424 7.5971 11.3268 7.5033C11.4112 7.40949 11.5144 7.33449 11.6296 7.28314C11.7449 7.2318 11.8697 7.20526 11.9958 7.20526C12.122 7.20526 12.2468 7.2318 12.3621 7.28314C12.4773 7.33449 12.5805 7.40949 12.6649 7.5033C12.7493 7.5971 12.813 7.70761 12.8519 7.82764C12.8909 7.94766 12.9042 8.07453 12.8909 8.20001L12.7609 13.42C12.7609 13.6215 12.6809 13.8149 12.5383 13.9574C12.3958 14.0999 12.2024 14.18 12.0009 14.18C11.7993 14.18 11.606 14.0999 11.4635 13.9574C11.321 13.8149 11.2408 13.6215 11.2408 13.42Z"
      fill="#000000"
    />
    <path
      d="M12 21.5C17.1086 21.5 21.25 17.3586 21.25 12.25C21.25 7.14137 17.1086 3 12 3C6.89137 3 2.75 7.14137 2.75 12.25C2.75 17.3586 6.89137 21.5 12 21.5Z"
      stroke="#000000"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
